import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

import GmAnalyticsWrapper from './GmAnalyticsWrapper.vue';
import GmAnalyticsDashboard from './pages/GmAnalyticsDashboard.vue';
import GmEnhancedAgentPerformanceMatrix from './pages/GmEnhancedAgentPerformanceMatrix.vue';
import GmExportConversations from './pages/GmExportConversations.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.GM_ANALYTICS,
  permissions: ['administrator', 'agent'],
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
  ],
};

const gmAnalyticsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/gm-analytics'),
      component: GmAnalyticsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'gm_analytics_dashboard', params: to.params };
          },
        },
        {
          path: 'dashboard',
          name: 'gm_analytics_dashboard',
          meta,
          component: GmAnalyticsDashboard,
        },
        {
          path: 'enhanced-agent-performance',
          name: 'gm_enhanced_agent_performance_matrix',
          meta,
          component: GmEnhancedAgentPerformanceMatrix,
        },
        {
          path: 'export-conversations',
          name: 'gm_export_conversations',
          meta,
          component: GmExportConversations,
        },
        // Additional intelligence module routes will be added in Phase 2
        // {
        //   path: 'conversations',
        //   name: 'gm_conversation_intelligence',
        //   meta,
        //   component: GmConversationIntelligence,
        // },
        // {
        //   path: 'sentiment',
        //   name: 'gm_sentiment_intelligence',
        //   meta,
        //   component: GmSentimentIntelligence,
        // },
        // {
        //   path: 'performance',
        //   name: 'gm_performance_intelligence',
        //   meta,
        //   component: GmPerformanceIntelligence,
        // },
        // {
        //   path: 'predictive',
        //   name: 'gm_predictive_intelligence',
        //   meta,
        //   component: GmPredictiveIntelligence,
        // },
        // {
        //   path: 'revenue',
        //   name: 'gm_revenue_intelligence',
        //   meta,
        //   component: GmRevenueIntelligence,
        // },
        // {
        //   path: 'compliance',
        //   name: 'gm_compliance_intelligence',
        //   meta,
        //   component: GmComplianceIntelligence,
        // },
        // {
        //   path: 'customer-experience',
        //   name: 'gm_customer_experience_intelligence',
        //   meta,
        //   component: GmCustomerExperienceIntelligence,
        // },
        // {
        //   path: 'operational',
        //   name: 'gm_operational_intelligence',
        //   meta,
        //   component: GmOperationalIntelligence,
        // }
      ],
    },
  ],
};

export default gmAnalyticsRoutes;
